import { useEffect, useRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import { attachRipple, attachMagnetic } from '../lib/effects';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'ghost';
  magnetic?: boolean;
  icon?: string; // FontAwesome class, e.g. 'fa-solid fa-arrow-right'
}

export function Button({
  children,
  variant = 'primary',
  magnetic = false,
  icon,
  className = '',
  ...rest
}: Props) {
  const ref = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const offs = [attachRipple(el)];
    if (magnetic) offs.push(attachMagnetic(el, 8));
    return () => offs.forEach((f) => f());
  }, [magnetic]);
  const cls =
    variant === 'primary'
      ? 'btn btn-primary'
      : 'btn btn-ghost text-surface-900 dark:text-surface-100';
  return (
    <button ref={ref} className={`${cls} ${className}`} {...rest}>
      {icon && <i className={icon} aria-hidden="true" />}
      <span>{children}</span>
    </button>
  );
}
